module.exports = __webpack_public_path__ + "img/avti_5.eede9d88.png";